import React, { useContext, useRef } from "react";
import { StateContext } from "../state/index";
import BaseContent from './BaseContent';
import { useCustomCSS } from "../utils/hooks";
import { get } from 'lodash/object';

export const BaseViewByConfigKey = ({configKey}) => {
  const [{configuration}] = useContext(StateContext);
  const componentRef = useRef();
  useCustomCSS(componentRef, configKey);

  return (
    <BaseContent {...get(configuration, configKey, {})} ref={componentRef} />
  );
};

export default BaseViewByConfigKey;
